<template>
  <div>
    <!-- Tìm kiếm -->
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý nhà phân
            phối</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên cơ sở phân phối:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên cơ sở phân phối" v-model="search.cTenCoSo" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="5"></el-option>
                  <el-option label="Bình thường" value="1"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="findPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div style="padding: 5px 10px" class="form-row d-flex justify-content-between w-100">
          <div class="col-md-6">
            <el-button type="primary" outline native-type="submit" @click="handleOpenAdd">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm cơ sở cung cầu</span>
            </el-button>
          </div>
          <div class="col-md-6" style="text-align:right">
            <el-button plain type="warning" style="margin-right:30px" title="Đồng bộ" @click=""
              v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i></el-button>
            <!-- <el-button plain icon="el-icon-s-grid" ></el-button> -->
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" :border="true" style="height: 100%"
            height="100%" fit stripe highlight-current-row>
            <el-table-column prop="" type="index" label="STT" width="120"></el-table-column>
            <el-table-column prop="c_ten_co_so_phan_phoi" label="Tên cơ sở" min-width="150"></el-table-column>
            <el-table-column prop="c_dia_chi" label="Địa chỉ" min-width="150"></el-table-column>
            <el-table-column prop="c_sdt" label="SĐT" align="center" width="150"></el-table-column>
            <el-table-column prop="d_ngay_tao" label="Ngày tạo" width="120">
              <template #default="scope">
                <span v-if="scope.row.d_ngay_tao">{{
                  momentDate(scope.row.d_ngay_tao)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="n_tinh_trang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.n_tinh_trang == 1" :size="size">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <!-- Button hành động -->
            <el-table-column width="160" align="center">
              <template #default="scope">
                <el-button type="primary" @click="handleOpenEdit(scope.row)" :disabled="scope.row.n_tinh_trang == 0">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>

                <el-button type="danger" @click="handleDelete(scope.row)" :disabled="scope.row.n_tinh_trang == 0"
                  v-loading.fullscreen.lock="isLoading">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="" @current-change="" :current-page.sync="tableData.pageNum"
          :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>
    <el-dialog v-model="centerDialogVisible" class="modalTemp" dataBackDrop="static" :show-close="false">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">{{ operation ? "Cập nhật" : "Thêm tin" }}</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="centerDialogVisible = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <el-form :model="validateForm" :rules="rules" ref="validateForm" label-width="150px" class="demo-ruleForm flex-column">
        <el-form-item label="Tên cơ sở" prop="cTenCoSo">
          <el-input :size="size" v-model="validateForm.cTenCoSo"></el-input>
        </el-form-item>
        <el-form-item label="Địa chỉ" prop="cDiaChi">
          <el-input :size="size" v-model="validateForm.cDiaChi"></el-input>
        </el-form-item>
        <el-form-item label="SDT" prop="cSDT">
          <el-input :size="size" v-model="validateForm.cSDT"></el-input>
        </el-form-item>

      </el-form>
      <template #footer>
        <el-button v-if="!operation" type="primary" @click="handleAdd()"
          v-loading.fullscreen.lock="isLoading">Thêm</el-button>
        <el-button v-if="operation" type="primary" @click="handleEdit()"
          v-loading.fullscreen.lock="isLoading">Lưu</el-button>
        <el-button outline type="danger" @click="handleClose">Thoát</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { useStore } from "vuex";
import { Distributor } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      store: useStore(),
      size: "",
      tableData: {
        content: [
        ]
      },
      search: {
        cTenCoSo: "",
        nTinhTrang: "5",
      },
      isSearchLoading: false,
      isLoading: false,
      centerDialogVisible: false,
      operation: false,
      validateForm: {
        cTenCoSo: "",
        cDiaChi: "",
        cSDT: "",
      },
      rules: {
        cTenCoSo: [
          { required: true, message: "Xin vui lòng nhập tên cơ sở phân phối", trigger: "blur", },
        ],
        cDiaChi: [
          { required: true, message: "Xin vui lòng nhập địa chỉ", trigger: "blur", },
        ],
        cSDT: [
          { required: true, message: "Xin vui lòng nhập số điện thoại", trigger: "blur", },
        ],
      },
      productList: [],
      fit: "cover",
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      selected: {},
    };
  },
  methods: {

    handleFindPage() {
      this.isSearchLoading = true
      this.pageRequest.columnFilters = {
        cTenCoSo: { value: this.search.cTenCoSo },
        nTinhTrang: { value: this.search.nTinhTrang }
      }
      this.store.dispatch(Distributor.findPageDistributor, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          this.isSearchLoading = false
        } else {
          ElMessage({ message: "Có lỗi xảy ra xin vui lòng thử lại sau", type: "error" })
          this.isSearchLoading = false
        }
      })
    },
    handleOpenAdd() {
      this.validateForm = {
        cTenCoSo: "",
        cDiaChi: "",
        cSDT: "",
      }
      this.operation = false
      this.centerDialogVisible = true
    },
    handleAdd() {
      this.$refs.validateForm.validate((valid) => {
        if (valid) {
          let pageRequest = {
            columnFilters: {
              cTenCoSo: { value: this.validateForm.cTenCoSo },
              cDiaChi: { value: this.validateForm.cDiaChi },
              cSDT: { value: this.validateForm.cSDT },
            }
          }
          this.store.dispatch(Distributor.insertDistributor, pageRequest).then(res => {
            if (res.code == 200) {
              ElMessage({ message: res.msg, type: "success" })
              this.centerDialogVisible = false
              this.handleSearch()
            } else {
              ElMessage({ message: res.msg, type: "error" })
              this.centerDialogVisible = false
            }
          })
        }
      })

    },
    handleOpenEdit(val) {
      this.selected = Object.assign({}, val)
      this.validateForm = {
        cTenCoSo: this.selected.c_ten_co_so_phan_phoi,
        cDiaChi: this.selected.c_dia_chi,
        cSDT: this.selected.c_sdt,
      }
      this.operation = true
      this.centerDialogVisible = true
    },
    handleEdit() {
      this.$refs.validateForm.validate((valid) => {
        if (valid) {
          let pageRequest = {
            columnFilters: {
              cTenCoSo: { value: this.validateForm.cTenCoSo },
              cDiaChi: { value: this.validateForm.cDiaChi },
              cSDT: { value: this.validateForm.cSDT },
              nMaCoSo: { value: this.selected.n_ma_co_so_phan_phoi },
            }
          }
          this.store.dispatch(Distributor.updateDistributor, pageRequest).then(res => {
            if (res.code == 200) {
              ElMessage({ message: res.msg, type: "success" })
              this.handleSearch()
              this.centerDialogVisible = false
            } else {
              ElMessage({ message: res.msg, type: "error" })
              this.centerDialogVisible = false
            }
          })
        }

      })
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa cơ sở phân phối " + val.c_ten_co_so_phan_phoi + " không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          let pageRequest = {
            columnFilters: {
              nMaCoSo: { value: val.n_ma_co_so_phan_phoi },
            }
          }
          this.store.dispatch(Distributor.deleteDistributor, pageRequest).then(res => {
            if (res.code == 200) {
              ElMessage({ message: res.msg, type: "success" })
              this.handleSearch()
              this.centerDialogVisible = false
            } else {
              ElMessage({ message: res.msg, type: "error" })
              this.centerDialogVisible = false
            }
          })
        })
    },
    handleSearch() {
      this.pageRequest.pageNum = 1
      this.handleFindPage()
    },
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleClose() {
      this.centerDialogVisible = false
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.handleFindPage()

  },
};
</script>
